type EventCallback = (this: Document, event: any) => any;
type EventType = keyof DocumentEventMap | string;
type EventsList = Record<string, EventCallback[]>;

export class EasyEvent {
  events: EventsList = {};

  on(
    type: EventType,
    listener: EventCallback,
    options?: boolean | AddEventListenerOptions
  ): void {
    if (!this.events[type]) {
      this.events[type] = [];
    }

    this.events[type].push(listener);

    document.addEventListener(type, listener, options);

    try {
      window.Breakdance.canvas.document.addEventListener(
        type,
        listener,
        options
      );
    } catch (e) {
      console.log("[EASY EVENT] No canvas element found.");
    }
  }

  once(type: EventType, listener: EventCallback): void {
    this.on(type, listener, { once: true });
  }

  off(
    type: EventType,
    listener: EventCallback,
    options?: boolean | AddEventListenerOptions
  ): void {
    document.removeEventListener(type, listener, options);

    try {
      window.Breakdance.canvas.document.removeEventListener(
        type,
        listener,
        options
      );
    } catch (e) {
      console.log("[EASY EVENT] No canvas element found.");
    }
  }

  removeAll(): void {
    for (const [type, listeners] of Object.entries(this.events)) {
      listeners?.forEach(listener => this.off(type, listener));
    }

    this.events = {};
  }
}

export const isCanvasEvent = (event: Event) => {
  const doc = window.Breakdance.canvas.document;
  const target = event.target as HTMLElement;
  return doc.contains(target);
};

export const normalizeEventPosition = (event: MouseEvent) => {
  if (isCanvasEvent(event)) {
    const iframe = document.getElementById("iframe-wrapper");
    const rect = iframe?.getBoundingClientRect();
    const offsetX = rect?.x || 0;
    const offsetY = rect?.y || 0;

    return {
      x: offsetX + event.clientX,
      y: offsetY + event.clientY,
      pageX: offsetX + event.pageX,
      pageY: event.pageY
    };
  }

  return {
    x: event.clientX,
    y: event.clientY,
    pageX: event.pageX,
    pageY: event.pageY
  };
};
